import http from './http.service';

export default {
    login(formData) {
        return new Promise((resolve, reject) => {
            http.post('/api/account/login', formData)
                .then(result => {
                    console.log('Login success: ')
                    const userInfo = result.data;
                    console.log('User info', userInfo)
                    localStorage.setItem('user', JSON.stringify(result.data));
                    resolve(userInfo);
                })
                .catch(result => {
                    reject(result);
                });
        });
    },
    register(formData) {
        return new Promise((resolve, reject) => {
            http.post('/api/account/register', formData)
                .then(result => {
                    localStorage.setItem('user', JSON.stringify(result.data));
                    resolve(result.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    logout() {
        // TODO: Send token to the blacklist api
        return new Promise((resolve, reject) => {
            http.post('/api/account/logout', {
                token: 'test' // TODO:
            }).then(result => {
                localStorage.removeItem('user');
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendResetPasswordMail(email) {
        return new Promise((resolve, reject) => {
            http.post('/api/account/sendResetPasswordMail', email)
                .then(result => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    resetPassword(formData) {
        return new Promise((resolve, reject) => {
            http.post('/api/account/resetPassword', formData)
                .then(result => {
                    localStorage.setItem('user', JSON.stringify(result.data));
                    resolve(result.data);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    currentUserClaims() {
        return new Promise((resolve, reject) => {
            http.get('/api/account/currentUserClaims')
                .then(result => {
                    resolve(result.data);
                })
                .catch(result => {
                    reject(result);
                });
        });
    },
}
